import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import markup from "ulysses/features/fb_select_dlg.html";

"use strict";

var token = null;
var fb_loader = Promise.Deferred();
var facebook_loaded = false;
function load_facebook() {
    if (!facebook_loaded) {
        facebook_loaded = true;
        require(["facebook"], function(fb) {
            fb.init({
                appId      : "618912098208565",
                xfbml      : true,
                version    : "v2.3"
            });
            fb_loader.resolve(fb);
        });
    }
    return fb_loader.promise();
}

function convert_to_long_token(response) {
    var short_token = response.authResponse.accessToken;
    return uly.api.start().follow("uly:admin").follow("uly:facebook").put(null, { "token":short_token, "token_type":"user"}).done(function(result) {
        console.log("got long lived token:", result.token);
        token = result.token;
    });
}

function ensure_page_permissions(fb) {
    var res = Promise.Deferred();
    fb.login(function(response) {
        convert_to_long_token(response).done(function() {
            res.resolve(response); });
    }, {scope:"manage_pages,publish_pages"});
    return res;
}

function enumerate_facebook_pages(fb, userid) {
    var res = Promise.Deferred();
    fb.api("/"+userid+"/accounts?access_token={0}".format(token.access_token), function(data) {
        res.resolve(data);
    });
    return res;
}

function ensure_user(fb, auth_data) {
    var res = Promise.Deferred();
    fb.api("/me", function(data) {
        data["access_token"] = auth_data.authResponse.accessToken
        uly.api.start().follow("uly:users").post(null, {"source":"facebook", "data":data}).done(function(result) {
            res.resolve(result);
        }).fail(res.reject);
    });
    return res;
}

function login_with_facebook(fb) {
    var res= Promise.Deferred();
    fb.login(function(response) {
        ensure_user(fb, response).done(function(result) {
            console.log("Logged in with facebook");
            res.resolve(result);
        }).fail(function(result) {
            console.error("Login with facebook failed:", arguments);
            res.reject(result);
        });

    }, {"scope":"email"});
    return res;
}
$.extend(uly.actions, {
    "login_facebook": function(ev, $elt, ui) {
        load_facebook().then(function(fb) {
            login_with_facebook(fb).fail(function(result){
                uly.actions.login(null, null, null, result.error);
            }).done(function() {
                uly.start();
            });
        });
    },
    "add_facebook_page": function(ev, $elt, ui) {
        load_facebook().then(function(fb) {
            return ensure_page_permissions(fb).then(function(fbAuth) {
                var page_selector_model = {
                    "pages":ko.observableArray([])
                };

                enumerate_facebook_pages(fb, fbAuth.authResponse.userID).done(function(result) {
                    var dialog_model = {
                        "token": token,
                        "pages": $.map(result.data, function(val,idx) {
                            var page = {
                                "title": val.name,
                                "category": val.category,
                                "selected": ko.observable(false),
                                "id": val.id,
                                "description": ko.observable(null),
                                "fb_link":ko.observable("https://www.facebook.com/pages/{0}/{1}".format(val.name, val.id)),
                                "picture_uri":ko.observable(null),
                                "token":val.access_token
                            };
                            fb.api("/{0}?fields=id,name,description,about,link,picture".format(page.id), function(fb_page) {
                                console.log("fethced fb page:", fb_page, " for page:", page);
                                if (fb_page) {
                                    page.description(fb_page.description || fb_page.about);
                                    if (fb_page.picture && fb_page.picture.data) {
                                        page.picture_uri(fb_page.picture.data.url);
                                    }
                                    page.fb_link(fb_page.link);
                                }
                            });
                            return  page;
                        }),
                    };
                    uly.dialogs.execute(markup, { "raw_data":true, "title":_("facebook_pages_title_associate_facebook_pages", "Associate Facebook Pages") }, dialog_model)
                        .done(function([page_data]) {
                        var to_post = $.map(page_data.pages, function(val) {
                            if (ko.unwrap(val.selected))
                                return val;
                            return null;
                        });
                        uly.api.start().follow("uly:admin").follow("uly:facebook").post(null, to_post).done(function(result) {
                            uly.utils.show_results(result);
                            uly.actions.navigateto("/admin/facebook");
                        }).fail(function(result) {
                            uly.utils.show_results(result);
                        });
                    });
                });
            });
        });
    }
});
